import { CForm, CSpinner } from '@coreui/react'
import React from 'react'
import CustomValuesHook from '../../../../Hooks/customValuesHook'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { DSLogo } from '../../../../components/images_module'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { postResetPassword } from '../../../../service/reactQueryServices/authService'
import { useMutation } from 'react-query'
import { Bounce, Flip, toast } from 'react-toastify'
import { EmailSVG } from '../../../../components/IconSvg'

const ResetPassword = ({ backToLogin }: { backToLogin: Function }) => {
    const { mutateAsync: resetPassword, isLoading } = useMutation("resetPass", postResetPassword);
    const { t } = useTranslation()
    const validation = Yup.object({
        email: Yup.string().email("ایمیل واردشده نامعتبر است").required("وارد کردن پست الکترونیک الزامی است."),
    })

    const handleSubmit = async (values: { email: string }) => {

        try {
            const response = await resetPassword({
                email: values.email,
                successUrl: encodeURIComponent('https://' + window.location.host + '/#/login/reset-password-success/'),
                failureUrl: encodeURIComponent('https://' + window.location.host + '/#/login/reset-password-failure/')
            })
            toast.success('ایمیل بازنشانی رمز عبور به ایمیل شما ارسال گردید. لطفا به ایمیل خود مراجعه نمایید.', {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 1,
                theme: "light",
                transition: Flip,
            })

        } catch (error) {
            toast.error("بروز خطا")
        }
    }
    const validate = () => { }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: { email: '' },
        onSubmit: handleSubmit,
        validate,
    })
    return (
        <div className='login-context'>

            <div className='logoHOlder d-flex justify-content-center'>
                <img alt='daftareshoma' src={DSLogo} />
            </div>
            <div className='page-box' >
                <div className='container-login reset-password col-xs-2 col-sm-12 col-md-8 col-lg-3 p-3'>
                    <div>
                        <form onSubmit={formik.handleSubmit} autoComplete="off">
                            <div className='d-flex flex-row justify-content-start loginTitle'>
                                <label>{t('RESET_PASSWORD')}</label>
                            </div>
                            <div className="form-group mt-3">
                                {/* <label htmlFor="exampleInputEmail1" className='d-flex flex-row justify-content-start lbl-frm' >{t('ENTER_YOUR_EMAIL')}</label> */}
                                <div className='res-pass-email-container' >
                                    <input type='email' name="email" id="exampleInputEmail1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' placeholder={t('Email') || ""} />
                                    {formik.errors.email && formik.touched.email && <label className='label-danger '>{formik.errors.email}</label>}
                                    <span> <EmailSVG /></span>

                                </div>


                                <p className='mt-3 mb-5'>جهت بازیابی رمز عبور آدرس ایمیل‌تان را وارد نمایید.</p>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <button onClick={() => backToLogin()} className="btn frm-btn-back"  >{t('BACK')}</button>

                                <button type="submit" style={{ height: '36px' }} className="btn  frm-btn  d-flex align-items-center  justify-content-center"
                                    disabled={isLoading}
                                >ادامه
                                    {isLoading && <CSpinner size='sm' color='light' className='mx-2' />}
                                </button>
                            </div>

                        </form>
                    </div>







                </div>
            </div>
            <div className='d-flex flex-row justify-content-center footerTxt'>
                <span>
                    {t('FOOTER')}
                </span>
            </div>

        </div>
    )
}

export default ResetPassword